const locale = {
    placeholder: 'Selecteer tijd',
    rangePlaceholder: ['Start tijd', 'Eind tijd'],
};
export default locale;
